import { api } from "../../app/api/api";
import SynchAddressesRequest from "../../models/synch/synchAddressesRequest";

export const synchElectionPlace = async (request: SynchAddressesRequest) => {
    return api.post("/synch/upload-election-places", request.file) as Promise<Response>;
};

export const updateMembersElectionPlace = async () => {
    return api.post("/synch/update-members-election-places") as Promise<Response>;
};